$(window).on("load resize scroll",function() {
    $('.panel-row').each(function(i, el) {
      var el = $(el);
      if (el.visible(true)) {
        el.addClass("panel-row--visible"); 
      } else {
        el.removeClass("panel-row--visible"); 
      }
    });
});

// $(window).on("load",function() {
//     var main = $('main');

//     if ($(this).scrollTop() >= 200) { 
//         main.removeClass('main--animate')
//     }
// });